import ServerDataGrid from "../../../components/datagrid/ServerDataGrid";
import { columns } from "./damageResolvedColumns";

export function DamageResolvedTablePage() {
  return (
    <ServerDataGrid
      initialStateOverride={{
        filter: {
          filterModel: {
            items: [{ field: "damage.damage_qty", operator: "<", value: 1 }],
          },
        },
      }}
      columns={columns}
      getRowId={(row) => row.damage.id}
      apiEndpoint="/datagrid/damage"
      tableName="damage"
      enableCreate={false}
      enableSearch={true}
    />
  );
}
